import { Component, CustomComponentManager, SelectManager } from '@easytwin/runtime';
import { message, Tooltip } from '@easyv/react-components';
import * as React from 'react';
import { useRequest } from 'ahooks';
import { observer } from 'mobx-react-lite';
import { ArrowBigUpOutlined } from '@easyv/react-icons';

interface UpgradeVersionIconProps {
  comp: Component | undefined;
}

export const UpgradeVersionIcon: React.FC<UpgradeVersionIconProps> = observer((props) => {
  const { comp } = props;

  const { data: isNeedUpdating } = useRequest(
    async () => {
      if (!(comp instanceof Component)) {
        return false;
      }

      const customComponentManager = comp.engine.getManager(CustomComponentManager);
      const isStale = await customComponentManager.isComponentStale(comp);
      return isStale;
    },
    {
      refreshDeps: [comp?.version],
    },
  );

  return (
    isNeedUpdating && (
      <Tooltip content='更新'>
        <div
          className='w-6 h-6 text-primary cursor-pointer hover:bg-FFFFFF0A flex items-center justify-center rounded'
          onClick={async (e) => {
            try {
              e.stopPropagation();
              if (!(comp instanceof Component)) return;
              const scene = comp.scene;
              const engine = comp.engine;
              const customComponentManager = engine.getManager(CustomComponentManager);
              const selectMgr = scene.getManager(SelectManager);

              const latest = await customComponentManager.getComponentLastVersion(comp.type);
              await scene.updateComponentVersion([{ comp, version: latest }]);
              const newVersionComp = scene.rootComponent?.findBy((a) => a.id === comp.id);
              selectMgr?.unSelectAll();
              if (!newVersionComp) {
                console.error('本次模块升级没有创建新组件');
                return;
              }
              const module = customComponentManager.get(
                newVersionComp.type,
                newVersionComp.version,
              );
              if (!module) {
                console.warn('模块升级: 找不到新版组件的module');
                return;
              }
              if (module.Settings.category === 'CustomComponent') {
                newVersionComp && selectMgr?.select([newVersionComp], false);
              } else if (module.Settings.category === 'FunctionalComponent') {
                engine.emit('functional-component-version-upgrade');
              }
              message.success(`${comp.name}已更新`);
            } catch (err) {
              console.error((err as Error).message);
              message.error((err as Error).message);
            }
          }}
        >
          <ArrowBigUpOutlined size={14} />
        </div>
      </Tooltip>
    )
  );
});
